module.exports = __webpack_public_path__ + "static/iot-device@2x-02027ed3722f5d0f24cde6c2bc50803d.png";